import { motion } from "framer-motion";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function NewsItem({ image_url, heading, id }) {
  return (
    <motion.div
      className="news-item"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
        <Link
          to={'/status/' + id}
          className="news-item w-100 h-100"
          rel="noopener noreferrer"
        >
      <div className="news-heading">
          {heading ||
            "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem quod nostrum id tenetur! Eaque, aperiam!"}
      </div>
      <div className="news-image-container">
        <img
          src={image_url || "https://via.placeholder.com/70"}
          alt="news"
          className="news-image"
          />
      </div>
      </Link>
    </motion.div>
  );
}
